module.exports = __webpack_public_path__ + "img/guide-title.ace60d0e.svg";